import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import Terminos from "./pages/Terminos";
import Privacidad from "./pages/Privacidad";
import Error404 from "./pages/Error404";
import { analyticsService } from "./analytics/analyticsService";
import { GoogleAnalytics } from "./seo/GoogleAnalytics";

// El dashboard arrastra pdfjs-dist y tesseract.js: se carga aparte para no
// penalizar el arranque del podcast.
const Boletin = lazy(() =>
  import("./components/dashboard/DashboardBase").then((m) => ({ default: m.Boletin }))
);

analyticsService.init();

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <GoogleAnalytics />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Compatibilidad: la PWA instalada apunta a esta ruta */}
          <Route path="/nuestravisiontv" element={<Navigate to="/" replace />} />
          <Route path="/bloques/*" element={<DashboardLayout />} />
          <Route path="/terminos-y-condiciones" element={<Terminos />} />
          <Route path="/aviso-de-privacidad" element={<Privacidad />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

const DashboardLayout = () => {
  return (
    <Suspense fallback={<p className="text-center text-white/40 text-sm italic py-10">Cargando...</p>}>
      <Routes>
        <Route path="boletin" element={<Boletin />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Suspense>
  );
};

export default App;
